import React from "react";
import Link from "next/link";
import parser from "html-react-parser";
import buttonHelper from "./../helpers/buttonHelper";
import { getImageURL } from "@/helpers/imageURLHelper";

const TileItem = ({
  buttonPage,
  image,
  linkText,
  linkUrl,
  fromPage,
  menu,
  title,
  target,
  shortText,
  page,
  news,
  course,
  concert,
}) => {
  const buttonPageUrl = buttonPage
    ? buttonHelper.findSlugPath(menu, buttonPage?.title)
    : null;
  const tileFullSelfUrl = buttonHelper.getLink(
    {
      page: page ?? null,
      news: news ?? null,
      course: course ?? null,
      concert: concert ?? null,
    },
    menu
  );

  const tileLink =
    fromPage?.cardInfo?.selfLink?.link ||
    linkUrl ||
    buttonPageUrl ||
    tileFullSelfUrl ||
    "#";

  const tileLinkText = linkText
    ? linkText
    : fromPage?.cardInfo?.selfLink?.title;
  const tileTitle = title || fromPage?.cardInfo?.title;
  const tileText = shortText || fromPage?.cardInfo?.description || "";
  const tileImage = image || fromPage?.cardInfo?.image?.data?.attributes || "";

  const tile = tileImage ? (
    <div className="grid-x">
      <div className="tps-card-item-image-wrapper cell shrink">
        <Link
          className="tps-card-item-image "
          href={tileLink}
          style={{
            backgroundImage: `url(${getImageURL(tileImage?.url)})`,
          }}
          aria-hidden="true"
          tabIndex="-1"
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
        />
      </div>
      <div className="tps-card-item-inner cell auto">
        <Link
          className="tps-card-item-title h4"
          href={tileLink}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
        >
          {tileTitle}
        </Link>
        <div className="tps-card-item-text">
          {tileText && parser(tileText?.replace(/^<p>(.*)<\/p>$/, "$1"))}
        </div>
        <div className="tps-card-item-actions">
          <Link
            className="tps-card-item-action "
            aria-hidden="true"
            tabIndex="-1"
            href={tileLink}
            target={target}
            rel={target === "_blank" ? "noopener noreferrer" : undefined}
          >
            {tileLinkText}
          </Link>
        </div>
      </div>
    </div>
  ) : (
    <>
      <Link
        className="tps-card-item-title h4"
        href={tileLink}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
      >
        {tileTitle}
      </Link>
      <div className="tps-card-item-text">
        {tileText && parser(tileText?.replace(/^<p>(.*)<\/p>$/, "$1"))}
      </div>
      <div className="tps-card-item-actions">
        <Link
          className="tps-card-item-action "
          aria-hidden="true"
          tabIndex="-1"
          href={tileLink}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
        >
          {tileLinkText}
        </Link>
      </div>
    </>
  );

  return <div className="tps-card-item compact cell">{tile}</div>;
};

export default TileItem;
